import { gangtokInstance as http } from "./http-common";

const token = JSON.parse(localStorage.getItem("token"));

const getChallanCount = (data) => {
  return http.post("ChallanCount/GetChallanCount", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getChallanCountNew = (depo, type) => {
  return http.post(
    `ChallanCountNew/GetChallanCountNEW?loc_id=${depo}&type=${type}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

const getBuscount = (data) => {
  return http.post("WorkshopCountDepowise/GetBuscount", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getFuelStatusGraph = (data) => {
  return http.post("fuelTankdata", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getGoodRequestedCount = (data) => {
  return http.post(
    `RequestReceive/GetRequestReciveCount?loc_id=${data.locId}&type=${data.type}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

const getRequestReciveCount = (data) => {
  return http.post("RequestReceiveMTV/CentDash_ReqReceivedCnt", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const cmtollCollection = (data) => {
  return http.post("ChargeReceipt/GetChargeReceipt", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getDepoDutyreport = (data) => {
  return http.post("GetDepoDutyreport", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getDailyTotalfuel = (data) => {
  return http.post("GetDailyTotalfuel", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const invoiceGeneration = (data) => {
  return http.post(
    `InvoiceAmount/GetInvoiceAmount?loc_id=${data.locid}&type=${data.type}&Vech_type=${data.vechType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

const CommonService = {
  getChallanCount,
  getChallanCountNew,
  getBuscount,
  getRequestReciveCount,
  getFuelStatusGraph,
  getGoodRequestedCount,
  cmtollCollection,
  getDepoDutyreport,
  getDailyTotalfuel,
  invoiceGeneration,
};

export default CommonService;
